import { default as SedaroMoon } from './sedaroMoon';

import { createCesiumComponent, PickCesiumProps } from 'resium';

// Adapted from resium/src/Moon/Moon.ts
// Changed to import our modified Cesium moon rather than the default
// Original code can be found here https://github.com/reearth/resium/blob/0beddb36deac6a5d5fd4997a3510653c0768aca0/src/Moon/Moon.ts
// Adapted from Resium under the MIT license found here https://github.com/reearth/resium/blob/main/LICENSE

// I've added the ts-ingnores at REF because the types don't seem to be read properly

/*
@summary
`Moon` can operate the moon of the scene.
All properties are applied to single moon of the scene.
*/

/*
@scope
Moon can be mounted inside[Viewer](/components/Viewer) or [CesiumWidget](/components/CesiumWidget) components.
It can not be mounted more than once for each Viewer or CesiumWidget.
*/

export type MoonCesiumProps = PickCesiumProps<SedaroMoon, typeof cesiumProps>;

export type MoonCesiumReadonlyProps = PickCesiumProps<SedaroMoon, typeof cesiumReadonlyProps>;

export type MoonProps = MoonCesiumProps & MoonCesiumReadonlyProps;

const cesiumProps = ['onlySunLighting', 'show', 'textureUrl'] as const;

const cesiumReadonlyProps = ['ellipsoid'] as const;

const Moon = createCesiumComponent<SedaroMoon, MoonProps>({
  name: 'Moon',
  create(context, props) {
    if (!context.scene) return;
    // @ts-ignore REF
    const element = new SedaroMoon(props);
    // @ts-ignore REF
    context.scene.moon = element;
    return element;
  },
  destroy(_element, context) {
    if (context.scene && !context.scene.isDestroyed()) {
      // @ts-ignore REF
      context.scene.moon = new SedaroMoon();
    }
    // if (!element.isDestroyed()) {
    //   element.destroy();
    // }
  },
  cesiumProps,
  cesiumReadonlyProps,
});

export default Moon;
